<section
  class="page-toolbar"
  [class.page-toolbar--filters-open]="isFiltersOpen()"
>
  <div class="page-toolbar__top-row">
    <div class="page-toolbar__title-block">
      @if (backLink) {
        <lib-icon-button
          class="page-toolbar__back-button"
          icon="arrow-left"
          buttonStyle="filled"
          [size]="24"
          [title]="'monitoring.back' | translate"
          [routerLink]="backLink"
        />
      }

      <h1 class="page-toolbar__title">{{ titleTranslateKey | translate }}</h1>

      <ng-content select="[toolbarNav]" />
    </div>

    @if (searchControl || showFiltersButton || actions.length > 0) {
      <div class="page-toolbar__controls">
        @if (searchControl) {
          <lib-input
            class="page-toolbar__search"
            [placeholder]="searchPlaceholderTranslateKey | translate"
            type="text"
            [formControl]="searchControl"
            [readonly]="searchDisabled"
          >
            <lib-icon-button
              class="suffix"
              icon="minimalistic-magnifer"
              [size]="20"
            />
          </lib-input>
        }

        @if (showFiltersButton) {
          <div
            #filtersPanelBtn
            class="page-toolbar__settings-wrapper"
          >
            <lib-icon-button
              class="page-toolbar__settings-button"
              icon="tuning"
              [size]="24"
              buttonStyle="filled"
              title="Filters"
              [attr.aria-expanded]="isFiltersOpen()"
              (click)="toggleFilters($event)"
            />

            @if (selectedFiltersCount > 0) {
              <span class="page-toolbar__filters-count">{{ selectedFiltersCount }}</span>
            }
          </div>
        }

        <div class="page-toolbar__inline-controls">
          <ng-content select="[toolbarInlineControls]" />
        </div>

        @for (action of actions; track action.id) {
          <button
            class="page-toolbar__action-button page-toolbar__action-button--icon-only"
            type="button"
            [title]="action.titleTranslateKey ?? '' | translate"
            [class.page-toolbar__action-button--disabled]="action.disabled"
            [attr.aria-disabled]="action.disabled"
            (click)="emitAction(action)"
          >
            <lib-svg-icon
              [icon]="action.icon"
              size="24"
            />
          </button>
        }
      </div>
    }
  </div>

  <!-- Строка фильтров, которая видна всегда, — в отличие от раскрывающейся панели ниже. -->
  <div class="page-toolbar__filter-bar">
    <ng-content select="[toolbarFilterBar]" />
  </div>

  @if (showFiltersButton) {
    <div
      class="page-toolbar__filters-panel"
      #filtersPanel
    >
      <div class="page-toolbar__filters-surface">
        <div class="page-toolbar__filters-scroll">
          <ng-content select="[toolbarFilters]" />
        </div>

        <div class="page-toolbar__selected-filters">
          <ng-content select="[toolbarSelectedFilters]" />
        </div>
      </div>
    </div>
  }
</section>
